import React, { useState, useEffect } from "react";
import CustomButton from "../../../components/AddButton";
import { truck, container, vehicle, edit, Plus, map } from "../../../common/svg";
import { bookingDetails } from "../../../common/staticData";
import { images } from "../../../common/tabs";
import CustomCard from "../../../components/Card";
import DaysLeftCounter from "../../../components/DaysProgress";
import CustomChip from "../../../components/Chip";
import DocumentUpload from "./components/Upload";
import TransportTracker from "./components/TransportTracker";
import DeliveryTimeline from "../../../components/DeliveryTimeline";
import ShippingFlow from "../../../components/TrackingStatus/Track";
import BookingDetails from "../view/components/Triptype";
import ExpenseList from "../view/components/Expense Details";
import ContainerVehicleDetails from "../view/components/container";
import LiveStatus from "../view/components/Livestatus";
import SecureImage from "../../../components/BucketImage/Image";
import InfiniteScrollContainer from "../../../components/InfiniteScroll/InfiniteScroll";
import { ApiService } from "../../../service/api.service";
import { ECHO_URL, OPERTIONS_URL } from "../../../common/common";
import SimpleLiveTrackingMap from "../../../components/LiveTracking/LiveTrackingMap";
import moment from "moment";
import { useParams } from "react-router-dom";
import { useLiveTracking } from "../../../hooks/useLiveTracking";

const Trip = () => {
  const apiService = new ApiService();
  const { id } = useParams();
  const [activeTripCard, setActiveTripCard] = useState<number | null>(null);
  const [viewTripDetails, setViewTripDetails] = useState<boolean>(false);
  const [hasMore, setHasMore] = useState(true);
  const entityId = localStorage.getItem("entity_id");
  const [isFetching, setIsFetching] = useState(false);
  const [page, setPage] = useState(1);
  const [allTrips, setAllTrips] = useState<any[]>([]);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [isBlurred, setIsBlurred] = useState(true);
  const {
    showMap,
    hasTrackingData,
    isLoading,
    error,
    startTracking,
    setFirstDataReceived,
    canShowMap,
    isInLoadingState
  } = useLiveTracking();
  const [vehcileDetails, setVehcileDetails] = useState<any>([]);
  const [surveyorDetails, setSurveyorDetails] = useState<any>([]);
  const [companyDetail, setCompanyDetails] = useState<any>({});
  const [driverDetails, setDriverDetails] = useState<any>([]);
  const [driverAssignments, setDriverAssignments] = useState<any>([]);

  const handleToggle = () => {
    setIsBlurred(!isBlurred);
  };

  const handleClick = () => {
    console.log("Button clicked!");
  };

  const handleViewTripDetails = (index: number) => {
    console.log("Trip ID:", allTrips[index].tripId);
    if (allTrips[index].tripId) {
      getTripById(allTrips[index].tripId);
    }
    setActiveTripCard(index);
    setViewTripDetails(true);
  };

  const fetchMoreData = async () => {
    if (!hasMore || isFetching) return;

    setIsFetching(true);

    try {
      const response: any = await apiService.getApi(
        `${OPERTIONS_URL}/trip/get-all-route?bookingId=${id || ""}`
      );

      if (response?.status === "200") {
        const newBookings = response.body.data || [];
        const pagination = response.body.pagination;

        setAllTrips((prev: any[]) => [...prev, ...newBookings]);

        // Update pagination details
        setHasMore(pagination.hasNextPage);
        setTotalRecords(pagination.totalRecords);

        if (pagination.hasNextPage) {
          setPage((prev) => prev + 1);
        }
      }
    } catch (error) {
      console.error("Error fetching bookings:", error);
      setHasMore(false);
    } finally {
      setIsFetching(false);
    }
  };

  const getTripById = async (id: string) => {
    try {
      const response: any = await apiService.getApi(
        `${OPERTIONS_URL}/trip/details-route?tripId=${id}`
      );
      if (response?.status === "200") {
        const tripDetails = response.body[0] || {};

        const vehicleAssignments = tripDetails.vehicleAssignments || [];
        // Ensure surveyorAssignments always has surveyorData for UI
        let surveyorAssignments = tripDetails.surveyorAssignments || [];
        let driverAssignments = tripDetails.driverAssignments || [];
        let companyDetail = tripDetails.companyDetail || {};

        console.log("Raw driver assignments from API:", driverAssignments);

        surveyorAssignments = surveyorAssignments.map((item: any) => {
          if (item.surveyorData) return item;
          // If surveyorData is missing, but fields are at root, wrap them
          const { firstName, lastName } = item;
          return {
            surveyorData: { firstName, lastName },
          };
        });

        setVehcileDetails(vehicleAssignments);
        setSurveyorDetails(surveyorAssignments);
        setDriverDetails(driverAssignments); // Keep this for backward compatibility
        setDriverAssignments(driverAssignments); // This is the main driver assignments data
        setCompanyDetails(companyDetail);

        console.log("Driver assignments set to state:", driverAssignments);
      }
    } catch (error) {
      console.error("Error fetching trip details:", error);
    }
  };

  const ShowMap = async () => {
    try {
      // Get vehicle registration number from trip details
      const currentTrip = allTrips[activeTripCard || 0];
      const vehicleRegNo = vehcileDetails?.[0]?.vechicleData?.vehicleRegNo;

      if (!vehicleRegNo) {
        console.error("No vehicle registration number found for this trip");
        return;
      }

      const success = await startTracking(vehicleRegNo);
      if (success) {
        setIsBlurred(false);
      }
    } catch (error) {
      console.error("❌ Error starting live tracking:", error);
    }
  };

  useEffect(() => {
    fetchMoreData();
  }, [entityId]);

  return (
    <div>
      <div className="bg-white p-2 rounded-[20px]">
        <div className="flex justify-between border-b border-[#C1C1C1] border-dashed p-2">
          <p className="text-[#444FBD] text-[16px] font-[600]">
            Trip Details ({totalRecords})
          </p>
          <CustomButton label="" icon={Plus} onClick={handleClick} />
        </div>
        <br />
        <div className="flex gap-2 mt-">
          {/* Left */}
          <InfiniteScrollContainer
            width="400px"
            fetchMoreData={fetchMoreData}
            hasMore={hasMore}
            isFetching={isFetching}
          >
            <div>
              {allTrips.map((booking, index) => (
                <CustomCard
                  key={index}
                  onClick={() => handleViewTripDetails(index)}
                  isActive={activeTripCard === index}
                  className="w-[350px] shadow-[1px_-1px_3.6px_2px_#00000033] p-2 rounded mb-2">
                  <div className="gap-[-1]">
                    <div className="flex justify-between items-center ">
                      <div className="flex items-center space-x-2">
                        <p className="font-semibold">
                          {booking.tripName || "Trip Name"}
                        </p>
                        <CustomChip
                          text={booking.bookingStatus || "Pending"}
                          textColor="#FF973C"
                          borderColor="#FF973C" />
                      </div>
                      <p className=" font-[400] text-[14px]">#0{index + 1}</p>
                    </div>
                    <div className=" flex justify-between">
                      <div className="leading-[18px]">
                        <p className="text-[14px]">#{booking.tripNumber}</p>
                        <p className="text-[14px] font-[400]">
                          {moment(booking.bookingDate).format("DD MMMM YYYY, hh:mma")}
                        </p>
                      </div>
                      <div className="flex items-center flex-col justify-center">
                        <DaysLeftCounter totalDays={booking.daysLeft || 5} />
                        <p className="text-[14px] font-[400]">Days left</p>
                      </div>
                    </div>
                    <div className="flex justify-between items-end">
                      <div className="flex flex-col leading-[15px]">
                        <p className="text-[14px]">Booking</p>
                        <p
                          className={`font-medium text-[14px] ${activeTripCard === index
                            ? "text-[#F7941D]"
                            : "text-[#444FBD]"
                            }`}
                        >
                          {booking.bookingName || "Client Name"}
                        </p>
                      </div>

                      <div className="leading-[15px]">
                        <p className="text-[14px] text-right text-[#F7941D] font-[300]">
                          Point
                        </p>
                        <p className="text-[16px] text-[#F7941D] font-[600]">
                          Clearance
                        </p>
                      </div>
                    </div>
                  </div>
                </CustomCard>
              ))}
            </div>
          </InfiniteScrollContainer>

          {viewTripDetails && activeTripCard !== null && (
            <div className="mt-[-20px] w-full border-l border-[#C1C1C1] border-dashed">
              <div className="flex flex-col w-full">
                <div className="flex justify-between w-full p-2">
                  <div className="flex items-center space-x-2 ">
                    <SecureImage
                      fileKey={truck}
                      alt="header icon"
                      width="89px"
                    />
                    <div>
                      <div className="flex items-center space-x-2 leading-[-15px]">
                        <p className="text-[#444FBD] text-[14px] font-[600]">
                          {allTrips[activeTripCard]?.tripName || "Trip Name"}
                        </p>
                        <CustomChip
                          text="Waiting for clearance"
                          textColor="#FF973C"
                          backgroundColor="#FFF5EC"
                          borderColor="#FF973C"
                        />
                      </div>
                      <p className="text-[14px] font-[400]">
                        {allTrips[activeTripCard]?.tripNumber}
                      </p>
                      <p className="text-[14px] font-[400]">
                        {moment(allTrips[activeTripCard]?.startingDateTime).format("DD MMMM YYYY, hh:mma")}
                      </p>
                    </div>
                  </div>
                  <div className="flex justify-end">
                    <div className="flex flex-col items-end ">
                      <div className="flex items-center ">
                        <DaysLeftCounter
                          totalDays={allTrips[activeTripCard]?.daysLeft || 5}
                        // currentDay={2} 
                        />
                        <p className="text-[14px] font-[400]">
                          Days left
                        </p>
                      </div>
                      <p className="text-[14px] font-[400]">
                        {moment(allTrips[activeTripCard]?.endingDateTime).format("DD MMMM YYYY, hh:mma")}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="flex flex-wrap text-center justify-center gap-6 p-4 ">
                  <BookingDetails id={allTrips[activeTripCard]?.tripId} />
                </div>
                <br />

                <div className="mt-5 w-[870px] ml-7">
                  <TransportTracker />
                  <ShippingFlow />
                </div>
                <br />

                <LiveStatus />
                <br />

                <ContainerVehicleDetails
                  handleClick={handleClick}
                  container={container}
                  vehicle={vehicle}
                  images={images}
                  tripData={allTrips[activeTripCard]}
                  vehcileDetails={vehcileDetails}
                  surveyorDetails={surveyorDetails}
                  driverDetails={driverDetails}
                  companyDetail={companyDetail}
                  onRefreshTripDetails={() => {
                    if (allTrips[activeTripCard]?.tripId) {
                      getTripById(allTrips[activeTripCard].tripId);
                    }
                  }}
                />

                <div className="p-2 flex flex-col gap-4">
                  <div className="flex items-center justify-between">
                    <p className="text-[16px] font-[600] leading-[30px]">
                      Route Points
                    </p>
                    <CustomButton label="" icon={edit} onClick={handleClick} />
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="">
                      <DeliveryTimeline />
                    </div>
                    <div className="w-[450px] h-[500px] rounded-[30px] mt-10 overflow-hidden relative">
                      {showMap ? (
                        <div className="w-full h-full">
                          <SimpleLiveTrackingMap
                            onFirstDataReceived={setFirstDataReceived}
                            showMap={hasTrackingData}
                          />
                        </div>
                      ) : (
                        <div
                          className="w-full h-full bg-gray-100 flex items-center justify-center text-gray-500 text-3xl font-semibold cursor-pointer"
                          onClick={ShowMap}
                        >
                          Show Map
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="p-2 border-b border-[#C1C1C1] border-dashed">
                  <div className="flex justify-between items-center">
                    <p className="text-[16px] font-[600] text-[#282828] leading-[30px]">
                      Expense Details
                    </p>
                    <div className="flex gap-2">
                      <CustomButton label="" icon={edit} onClick={handleClick} />
                      <CustomButton label="" icon={Plus} onClick={handleClick} />
                    </div>
                  </div>
                  <ExpenseList />
                </div>

                <div>
                  <DocumentUpload />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Trip;